<template>
  <v-card-text style="padding-left: 0px">
    <v-sheet min-height="70vh" rounded="lg">
      <header-small :text="$t('AdminPage.Api.header')" />
      <p v-text="$t('AdminPage.Api.organizationId') + ': ' + apiInfo.organization_id" />
      <p v-text="$t('AdminPage.Api.licenceKey') + ': ' + apiInfo.license_id" />
      <p v-text="$t('AdminPage.Api.interfaceID') + ': ' + apiInfo.interface_id" />
    </v-sheet>
  </v-card-text>
</template>

<script>
import HeaderSmall from "../../components/ui/text/HeaderSmall.vue";
import HeaderBig from "../../components/ui/text/HeaderBig.vue";
import ToggleButton from "../../components/ui/input/ToggleButton.vue";
import Tokens from "../../pages/AdminPage/Tokens.vue";
import User from "../../pages/AdminPage/Users.vue";
import Whitelabeling from "../../pages/AdminPage/Whitelabeling.vue";
import Account from "../../pages/AdminPage/Account.vue";
import Organization from "./Organization.vue";
import { log } from "@/helpers/logger";

export default {
  name: "Api",
  components: {
    HeaderSmall,
    HeaderBig,
    ToggleButton,
    Tokens,
    User,
    Whitelabeling,
    Account,
    Organization,
  },
  data() {
    return {
      apiInfo: {},
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {

      this.$store
        .dispatch("data/getAccountInformations", this.$store.state.auth.user.id)
        .then((res) => {
          log(
            "AdminPage.index.getData() - get Api Informations for " +
            this.$store.state.auth.user.id,
            "info"
          );
          this.apiInfo = res
        })
        .catch((err) => {
          log("AdminPage.index.getData() - " + err, "error");
        });
    },
  },
};
</script>
